import * as React from 'react';
import { useState } from 'react';
import { Link, Route, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { authAxios } from '../../services/AxiosService';
import * as H from 'history';
import { Container, Nav, NavItem, NavLink } from 'reactstrap';
import { IUser } from './UsersTable';
import { UserDetails } from './UserDetails';
import { UserEmailHistory } from './UserEmailHistory';
import { UserEmailView } from './UserEmailView';
import { UserLoginHistory } from './UserLoginHistory';
import { UserActivityLog } from './UserActivityLog';

export const User = () => {
  const [user, setUser] = useState<IUser | undefined>(undefined);
  const params = useParams<{ userId: string; tab?: string }>();
  const userId = params.userId;

  useEffect(() => {
    authAxios.get('/api/users/admin/' + userId).then((response) => {
      const user = response.data;
      setUser(user);
    });
  }, [userId]);

  const tab: string = params.tab || 'details';

  const NavItemLink = (to: H.LocationDescriptor, active: boolean, name: any) => {
    return (
      <NavItem>
        <NavLink tag={Link} to={to} active={active}>
          {name}
        </NavLink>
      </NavItem>
    );
  };

  return (
    <article className='page'>
      <header className='page-header'>
        <Container fluid={true}>
          {user !== undefined && (
            <div className='d-flex flex-column py-3'>
              <h1 className='page-header__title order-2'>{user?.lastName.toUpperCase() + ', ' + user?.firstName}</h1>
              <h2 className='page-header__id order-1 text-primary'>{user?.email}</h2>
            </div>
          )}
          <div className='d-none d-md-block'>
            <Nav tabs={true}>
              {NavItemLink('/users/' + params.userId + '/details', tab === 'details', 'Details')}
              {NavItemLink('/users/' + params.userId + '/emails', tab === 'emails', 'Emails')}
              {NavItemLink('/users/' + params.userId + '/login-history', tab === 'login-history', 'Login History')}
              {NavItemLink('/users/' + params.userId + '/activity-log', tab === 'activity-log', 'Activity Log')}
            </Nav>
          </div>
          <div className='d-block d-md-none pb-4'>
            <Nav pills={true} vertical={true}>
              {NavItemLink('/users/' + params.userId + '/details', tab === 'details', 'Details')}
              {NavItemLink('/users/' + params.userId + '/emails', tab === 'emails', 'Emails')}
              {NavItemLink('/users/' + params.userId + '/login-history', tab === 'login-history', 'Login History')}
              {NavItemLink('/users/' + params.userId + '/activity-log', tab === 'activity-log', 'Activity Log')}
            </Nav>
          </div>
        </Container>
      </header>

      <Route exact={true} path='/users/:userId/(details)?' component={UserDetails} />
      <Route exact={true} path='/users/:userId/emails' component={UserEmailHistory} />
      <Route exact={true} path='/users/:userId/emails/:emailMessageId' component={UserEmailView} />
      <Route exact={true} path='/users/:userId/login-history' component={UserLoginHistory} />
      <Route exact={true} path='/users/:userId/activity-log' component={UserActivityLog} />
    </article>
  );
};
